export function sleep(ms: number): Promise<undefined> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(undefined), ms);
  });
}

export function assertNever(x: never): never {
  throw new Error(`Unexpected value: ${x}`);
}

// From: https://github.com/manishsaraan/email-validator/blob/master/index.js
const emailTester =
  /^[\w!#$%&'*+-/=?^{|}~](\.?[\w!#$%&'*+-/=?^`{|}~])*@[\dA-Za-z](-*\.?[\dA-Za-z])*\.[A-Za-z](-?[\dA-Za-z])+$/;
export function validateEmail(email: string) {
  if (!email || email.length > 254) {
    return false;
  }

  const valid = emailTester.test(email);
  if (!valid) {
    return false;
  }

  // Further checking of some things regex can't handle
  const parts = email.split('@');
  if (parts[0].length > 64) {
    return false;
  }

  const domainParts = parts[1].split('.');
  return domainParts.every((part) => part.length <= 63);
}

export function isSafeRedirectUrl(next: string): boolean {
  if (!next.startsWith('/') || next.startsWith('//')) {
    return false;
  }
  try {
    const resolved = new URL(next, window.location.origin);
    return resolved.origin === window.location.origin;
  } catch {
    return false;
  }
}

export function getCookie(name: string) {
  return document.cookie.match(new RegExp(`${name}=(.*?)(;|$)`))?.[1];
}

export function withoutQueryString(url: string) {
  return url.split(/[?#]/, 1)[0];
}
